import React, { useEffect, useState } from "react";
import { useAccount, useBlockNumber } from "wagmi";
import { useQueryClient } from "@tanstack/react-query";
import {
  useGetCurrentPresaleRound,
  useGetTokenSoldByRound,
} from "../../services/contract";
import PresaleRound from "../PresaleRound";

const SalesTabContent = () => {
  const [presaleRounds, setPresaleRounds] = useState([
    {
      id: 1,
      name: "Round 1",
      price: 0.26,
      totalTokens: 90,
      soldTokens: 0,
      status: "active",
    },
    {
      id: 2,
      name: "Round 2",
      price: 0.32,
      totalTokens: 120,
      soldTokens: 0,
      status: "upcoming",
    },
    {
      id: 3,
      name: "Round 3",
      price: 0.45,
      totalTokens: 90,
      soldTokens: 0,
      status: "upcoming",
    },
  ]);
  const queryClient = useQueryClient();
  const { address: walletAddress } = useAccount();
  const { data: blockNumber } = useBlockNumber({ watch: true });

  // Use the contract services from the services folder
  const { data: currentRound, queryKey: CurrentPresaleRoundQueryKey } =
    useGetCurrentPresaleRound();
  const { data: soldTokens1, queryKey: soldTokens1QueryKey } =
    useGetTokenSoldByRound(1);
  const { data: soldTokens2, queryKey: soldTokens2QueryKey } =
    useGetTokenSoldByRound(2);
  const { data: soldTokens3, queryKey: soldTokens3QueryKey } =
    useGetTokenSoldByRound(3);

  useEffect(() => {
    queryClient.invalidateQueries({ CurrentPresaleRoundQueryKey });
    queryClient.invalidateQueries({ soldTokens1QueryKey });
    queryClient.invalidateQueries({ soldTokens2QueryKey });
    queryClient.invalidateQueries({ soldTokens3QueryKey });
  }, [blockNumber]);

  useEffect(() => {
    if (
      currentRound !== undefined &&
      soldTokens1 !== undefined &&
      soldTokens2 !== undefined &&
      soldTokens3 !== undefined
    ) {
      setPresaleRounds((prevRounds) => {
        const updatedRounds = [...prevRounds];

        // Update sold tokens for each round
        updatedRounds[0].soldTokens = Number(soldTokens1) / 10 ** 18 || 0;
        updatedRounds[1].soldTokens = Number(soldTokens2) / 10 ** 18 || 0;
        updatedRounds[2].soldTokens = Number(soldTokens3) / 10 ** 18 || 0;

        // Update status based on currentRound
        const roundNumber = Number(currentRound);

        // Set all statuses based on current round
        updatedRounds.forEach((round, index) => {
          if (index < roundNumber) {
            round.status = "ended";
          } else if (index === roundNumber) {
            if (round.soldTokens === round.totalTokens) {
              round.status = "ended";
            } else {
              round.status = "active";
            }
          } else {
            round.status = "upcoming";
          }
        });

        return updatedRounds;
      });
    }
  }, [currentRound, soldTokens1, soldTokens2, soldTokens3]);

  return (
    <div className="row g-4">
      {presaleRounds.map((round) => (
        <div className="col-md-4" key={round.id}>
          <PresaleRound
            round={round}
            isWalletConnected={Boolean(walletAddress)}
          />
        </div>
      ))}
    </div>
  );
};

export default SalesTabContent;
